import { render, staticRenderFns } from "./PreviewNavigationRail.vue?vue&type=template&id=3fe6bc4a&scoped=true&"
import script from "./PreviewNavigationRail.vue?vue&type=script&lang=js&"
export * from "./PreviewNavigationRail.vue?vue&type=script&lang=js&"
import style0 from "./PreviewNavigationRail.vue?vue&type=style&index=0&id=3fe6bc4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe6bc4a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
